import _      from 'lodash';
import moment from 'moment';

// CONSIDER:
// - should we move serialization logic to serializers?
// - it obviously has design advantages and it could simplify Relation,
//   if we pull stuff like deserializeOne and deserializeMany from there as well
// - but is it practical at this point?

export default class Model {
  static primaryKey      = 'id';
  static nominativeName  = 'not given';
  static accusativeName  = 'not given';
  static onlyAttrs       = null;
  static attrNameMapping = {};

  get pk()         { return this[this.constructor.primaryKey]; }
  get attributes() { return _.omit(this, 'associations');      }

  with(params) {
    // FIXME: assign and extend lose properties defined by Object.defineProperty,
    // but so does { ...this }. cloneDeep even loses nested ones
    return _.assign(_.cloneDeep(this), params);
  }

  static with(params) {
    return (new (this)).with(params);
  }

  static serialize(instance) {
    // TODO: require each model to define @attributes list and map over these
    // this way we won't overwrite associations, etc.
    // add @foreignKeys - will utomatically append ID to these attributes

    let attrs = _.omit(instance, 'associations', 'createdAt', 'updatedAt');

    if (this.onlyAttrs) { attrs = _.pick(attrs, this.onlyAttrs); }

    return this.attrsToBackendNames(attrs);
  }

  static deserialize(row) {
    row = _.omit(row, 'links');

    let attrs = this.attrsToFrontendNames(row);

    if (row.created_at) { attrs.createdAt = moment(row.created_at); }
    if (row.updated_at) { attrs.updatedAt = moment(row.updated_at); }
    if (this.onlyAttrs) { attrs = _.pick(attrs, this.onlyAttrs);    }

    return this.with(attrs);
  }

  static attrsToFrontendNames(row) {
    return _.mapKeys(row, (_val, field) => this.frontendNameFor(field));
  }

  static attrsToBackendNames(instance) {
    return _.mapKeys(instance, (_val, attr) => this.backendNameFor(attr));
  }

  static backendNameFor(attribute) {
    return this.attrNameMapping[attribute] ?? _.snakeCase(attribute);
  }

  static frontendNameFor(attribute) {
    return _.invert(this.attrNameMapping)[attribute] ?? _.camelCase(attribute);
  }
};
